import axios from "axios";
import { toast } from "sonner";
import { Money } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { runBrowserHandoffs } from "@/utils/webusbPrinter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Cash tender panel. Just guidance text + a manual drawer-open button
 * for making change. The drawer also fires automatically on payment
 * confirmation — this button is a manual escape hatch for the odd
 * "customer wants to break a $100 first" scenario.
 */
const CashPanel = ({ total, orderId }) => (
  <div className="text-center py-6 text-muted-foreground">
    <Money size={40} className="mx-auto mb-2 opacity-30" />
    <p>Collect ${total.toFixed(2)} in cash</p>
    <p className="text-xs mt-1">The drawer will pop automatically when you confirm.</p>
    <Button
      variant="outline"
      size="sm"
      className="mt-3 gap-2"
      onClick={async () => {
        try {
          const dr = await axios.post(`${API}/cash-drawer/open`, {
            reason: "manual (cash tab)",
            order_id: orderId,
          });
          const { errors } = await runBrowserHandoffs(dr.data?.browser_handoff_results);
          if (errors.length) {
            toast.warning(`Drawer opened with warnings: ${errors.join(" · ")}`, { duration: 7000 });
          } else {
            toast.success("Cash drawer opened");
          }
        } catch {
          toast.error("Failed to open drawer");
        }
      }}
      data-testid="open-drawer-cash-tab-btn"
    >
      <Money size={16} /> Open Drawer for Change
    </Button>
  </div>
);

export default CashPanel;
